module.exports = __webpack_public_path__ + "static/media/more-life-videos.e252f086.md";